
import Button from '../../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/b7cf99f74a4338479083ec819dcf52c4.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="w-full">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Contabilidad Profesional Simplificada
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
              Servicios expertos de contabilidad con Microsoft Business Central. Optimice sus finanzas con precios transparentes y registro sencillo.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => handleNavigation('/es/contact')} 
                size="lg"
                className="text-lg"
              >
                Comience Hoy
                <i className="ri-arrow-right-line ml-2 text-lg"></i>
              </Button>
              <Button 
                onClick={() => scrollToSection('pricing')} 
                variant="outline" 
                size="lg"
                className="text-lg bg-white/10 border-white text-white hover:bg-white hover:text-gray-900"
              >
                Ver Precios
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}